import SigamAPI from '~/utils/SigamAPI';

export default async function ReadTemplate({ institutionId, templateId }) {
  const response = await SigamAPI({
    url: `/SIGAM/${institutionId}/communication-model/${templateId}`,
    method: 'GET',
  });

  return response;
}
